export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5262.98cf9317.jpg";